var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVrboIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 80.6 74.4"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#8ec089",
  d: "m40.8 53.6 2-4.1-6.7-34.1C34.2 5.8 36.4 1.6 44 .2V0h-7c-2 1-6.3 4-3.9 15.4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#e85f24",
  d: "m36.8 61.9 2-4.1L30 15.2C28.4 7 29.1 2.7 31.8.2V0h-4.7c-1.5 3.1-1.9 6.2-.3 14.3z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#318eee",
  d: "M15 .1h-5v.2c2.2 2.7 2.8 5.9 4.6 13.1l13.2 61h2.9L17.6 13.2C15.8 5.2 15.5 3.1 15 .1"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#2474de",
  d: "m32.9 70.1 2-4-11-51.8C22 6.2 22.4 2.6 23.2 0H19c-.1 3.3.1 6 1.6 12.9z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#76c5f7",
  d: "M5.2.1H0v.2c4.8 1.9 7.2 5.6 9.1 14.1 0 .1 13 60 13 60H25L11.9 13.9C9.6 3.4 7.2 1.5 5.2.1"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#e85f24",
  d: "m54.3 26.7.2.2C61.9 9.5 63.8 4.7 66.8.2V0h-5.9v.2c.5 6.9-1.9 13.3-6.6 26.5"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#2474de",
  d: "M72.4.1c-6.2 3.6-9.9 10.4-17.7 27l.2.2C63.8 10.6 69 3.9 80.6.3V.1z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#8ec089",
  d: "m53.9 26.4.2.2C58.7 11.1 60.3 4.2 56.2.1h-5.8v.2c6.4 2.2 7.8 8.8 3.5 26.1"
})));
export { SvgVrboIcon as ReactComponent };
export default __webpack_public_path__ + "9f565c0511fd282e145d77d8381ab8aa.svg";